module.exports = __webpack_public_path__ + "img/hongm.26059539.png";